"use strict";
exports.__esModule = true;
exports.generateLegendColorData = exports.getPushpinColors = exports.getColorPaletteMapping = exports.getColorIndexInPalette = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var range_1 = tslib_1.__importDefault(require("lodash/range"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isFinite_1 = tslib_1.__importDefault(require("lodash/isFinite"));
var geoChart_1 = require("./constants/geoChart");
var colors_1 = require("./helpers/geoChart/colors");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var common_1 = require("./helpers/geoChart/common");
var DEFAULT_SEGMENT_ITEM = "default_segment_item";
var DEFAULT_COLOR_INDEX_IN_PALETTE = geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE - 1;
function getColorIndexInPalette(value, min, max) {
    if (value === null || !isFinite_1["default"](value) || min === max || value === min) {
        return 0;
    }
    if (value === max) {
        return DEFAULT_COLOR_INDEX_IN_PALETTE;
    }
    var step = (max - min) / geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE;
    for (var i = 0, offset = min; i < geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE; i++, offset += step) {
        if (offset >= value) {
            return i;
        }
    }
    return DEFAULT_COLOR_INDEX_IN_PALETTE;
}
exports.getColorIndexInPalette = getColorIndexInPalette;
function getColorPaletteMapping(colorStrategy) {
    var colorAssignment = colorStrategy.getColorAssignment();
    return colorAssignment.reduce(function (result, item, index) {
        var _a, _b;
        var color = colorStrategy.getColorByIndex(index);
        var colorPalette = colors_1.getColorPalette(color, geoChart_1.DEFAULT_PUSHPIN_COLOR_OPACITY);
        // color base on Location
        if (sdk_backend_spi_1.isAttributeDescriptor(item.headerItem)) {
            return _a = {},
                _a[DEFAULT_SEGMENT_ITEM] = colorPalette,
                _a;
        }
        // color base on SegmentBy
        var name = sdk_backend_spi_1.isResultAttributeHeader(item.headerItem)
            ? item.headerItem.attributeHeaderItem.name
            : DEFAULT_SEGMENT_ITEM;
        return tslib_1.__assign(tslib_1.__assign({}, result), (_b = {}, _b[name] = colorPalette, _b));
    }, {});
}
exports.getColorPaletteMapping = getColorPaletteMapping;
/**
 * Return RGB border and background colors base on color and segment values
 *
 * Example:
 * ```
 *  [any-number] => [{
 *       border: "rgb(127,224,198)",
 *       background: "rgb(215,242,250)",
 *  }]
 * ```
 */
function getPushpinColors(colorValues, segmentValues, colorStrategy) {
    if (segmentValues === void 0) { segmentValues = []; }
    var defaultColorValue = colorStrategy.getColorByIndex(0);
    var defaultColor = colors_1.rgbToRgba(defaultColorValue, geoChart_1.DEFAULT_PUSHPIN_COLOR_OPACITY);
    if (!colorValues.length && !segmentValues.length) {
        return [
            {
                border: geoChart_1.DEFAULT_PUSHPIN_BORDER_COLOR_VALUE,
                background: defaultColor
            },
        ];
    }
    var segmentNames = tslib_1.__spreadArrays(segmentValues);
    var colorPaletteMapping = getColorPaletteMapping(colorStrategy);
    if (!colorValues.length) {
        return segmentNames.map(function (name) {
            var palette = colorPaletteMapping[name];
            return {
                border: geoChart_1.DEFAULT_PUSHPIN_BORDER_COLOR_VALUE,
                background: palette[DEFAULT_COLOR_INDEX_IN_PALETTE]
            };
        });
    }
    var colorsWithoutNull = colorValues.filter(function (value) { return value !== null && isFinite_1["default"](value); });
    var _a = common_1.getMinMax(colorsWithoutNull), min = _a.min, max = _a.max;
    if (min === max && !segmentValues.length) {
        return [
            {
                border: geoChart_1.DEFAULT_PUSHPIN_BORDER_COLOR_VALUE,
                background: defaultColor
            },
        ];
    }
    return colorValues.map(function (color, index) {
        var value = color !== null && isFinite_1["default"](color) ? color : min;
        var colorIndex = getColorIndexInPalette(value, min, max);
        var segmentItemName = segmentNames[index] || DEFAULT_SEGMENT_ITEM;
        var palette = colorPaletteMapping[segmentItemName];
        return {
            border: palette[DEFAULT_COLOR_INDEX_IN_PALETTE],
            background: palette[colorIndex]
        };
    });
}
exports.getPushpinColors = getPushpinColors;
function generateLegendColorData(colorSeries, colorString) {
    if (isEmpty_1["default"](colorSeries)) {
        return [];
    }
    var colorPalette = colors_1.getColorPalette(colorString, geoChart_1.DEFAULT_PUSHPIN_COLOR_OPACITY);
    var min = Math.min.apply(Math, colorSeries);
    var max = Math.max.apply(Math, colorSeries);
    var offset = (max - min) / geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE;
    if (min === max) {
        return [];
    }
    return range_1["default"](0, geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE).map(function (index) {
        var from = min + offset * index;
        var isLastItem = index === geoChart_1.DEFAULT_PUSHPIN_COLOR_SCALE - 1;
        var to = isLastItem ? max : from + offset;
        var range = {
            from: from,
            to: to
        };
        return {
            range: range,
            color: colorPalette[index]
        };
    });
}
exports.generateLegendColorData = generateLegendColorData;
//# sourceMappingURL=geoChartColor.js.map